<template>
  <div class="main">
    <div class="header">
      <div class="branding">
        <img class="logo" src="../assets/img/道乐科技icon.svg" alt="">
        <span class="brand-name">{{ branding }}</span>
      </div>
      <div v-if="$store.state.debugMode" style="background: red;font-size:10px;padding:5px 10px;margin-left:10px;border-radius: 5px;color:white; ">DEBUG</div>

      <div style="
      display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
">
        <shortcut-buttons :shortcuts="defaultTabs" :active="editableTabsValue" v-show="debug" @tab-change="tabChange"/>
        <div v-show="!debug"></div>

        <div class="settings">
          <div class="doc">
            <!-- <a href="https://szltech.gitbook.io/dao/">产品文档</a> -->
            <!-- 新版入口：与站内“进入新版”统一为胶囊 CTA；导航栏本身是蓝色，这里用白底蓝字，不引入新颜色 -->
            <a class="doc-new-version" href="/dao">
              <span class="doc-new-version__badge">NEW</span>
              <span class="doc-new-version__text">进入新版</span>
              <i class="el-icon-arrow-right doc-new-version__arrow"></i>
            </a>
          </div>
          
          <!-- 用户名 + 退出登录收进一个用户下拉，减少顶部常驻元素，整体更紧凑 -->
          <!-- 注意：el-dropdown（2.15.x）没有 popper-class 属性，浮层类名要加在 el-dropdown-menu 上 -->
          <el-dropdown
              class="user-menu"
              trigger="hover"
              placement="bottom-end"
              @command="handleUserCommand">
            <div class="user-menu__trigger">
              <i class="el-icon-user-solid user-menu__avatar"></i>
              <span class="user-menu__name">{{ username }}</span>
              <i class="el-icon-arrow-down user-menu__caret"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="user-menu__popover">
              <el-dropdown-item command="scale">
                <i class="el-icon-zoom-in user-menu__scale-icon"></i>显示比例
                <span class="user-menu__scale-current">{{ zoomText() }}</span>
              </el-dropdown-item>
              <el-dropdown-item command="logout" divided>
                <i class="el-icon-switch-button user-menu__logout-icon"></i>退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="tab">
        <el-tabs class="tab2" v-model="editableTabsValue" type="border-card" closable @edit="handleTabsEdit">
          <el-tab-pane
              v-for="item in editableTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
              :projectId="item.project_id"
          >
            <keep-alive>
              <component :is="item.content" :projectId="item.project_id" :accu="item.accu"
                         :key="item.name" :refreshId="refreshId"></component>
            </keep-alive>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 显示比例：本机字号偏小时可手动覆盖自动判断（见 utils/displayScale.js） -->
    <el-dialog
        title="显示比例"
        :visible.sync="scaleDialogVisible"
        width="380px"
        append-to-body>
      <el-radio-group v-model="displayScalePref" class="scale-group" @change="handleScaleChange">
        <el-radio
            v-for="opt in scaleOptions"
            :key="String(opt.value)"
            :label="String(opt.value)"
            class="scale-radio"
        >{{ opt.value === 'auto' ? '自动（按屏幕密度判断，当前 ' + zoomText() + '）' : opt.label }}</el-radio>
      </el-radio-group>
      <div v-if="scaleOverflowTip()" class="scale-warn">{{ scaleOverflowTip() }}</div>
      <div class="scale-tip">
        字号观感取决于屏幕密度：Mac Retina 通常需要放大，Windows 100% 缩放保持 100% 即可。选择结果记在本机浏览器。
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Performance from "@/component/Performance/Performance";
import FinanceDept from "@/component/FinanceDept/FinanceDept";
import TodoList from "@/component/TodoList/TodoList";
import ProjectList from '../component/ProjectList.vue'
import ProjectDetail from '../component/ProjectDetail.vue'
import DataStatistics from "@/component/DataStatistics/DataStatistics";
import shortcutButtons from '../component/topBar/shortcutButtons.vue'
import ServerManage from "@/component/ServerManage/ServerManage";
import PrePayManage from "@/component/PrePayManage/PrePayManage";
import PrizeAccount from "@/component/PrizeAccount/PrizeAccount";
import Business from "@/component/Business/Business";
import Client from "@/component/Client/Client";
import My from "@/component/My/My";
import Item from "@/component/Item/Item";
import achievements from "@/component/achievements/achievements";
import purchase from "@/component/purchase/purchase";
import {getMessage, performancePermission, userDept} from "@/api/api";
import { salesManager, departmentManager, businessManager, DataStatisticsManager, performanceManager, projectManager, opsManager, clueWhite } from "../config/index";
// 显示比例：高密度屏（Mac Retina 等）默认自动放大，用户可在用户下拉里手动覆盖
import { SCALE_OPTIONS, applyZoom, getScalePref, setScalePref, describeZoom, hasHorizontalOverflow } from "@/utils/displayScale";


export default {
  components: {
    ProjectList,
    TodoList,
    ProjectDetail,
    shortcutButtons,
    Performance,
    FinanceDept,
    DataStatistics,
    ServerManage,
    PrePayManage,
    PrizeAccount,
    Business,
    My
  },
  provide() {
    return {
      tabChange: this.tabChange
    }
  },
  data() {
    return {
      debug:false,
      branding: "DAO",
      username: this.$cookies.get("username"),
      // 显示比例（见 utils/displayScale.js）：高密度屏默认自动放大，用户可手动覆盖
      scaleDialogVisible: false,
      displayScalePref: 'auto',
      currentZoom: 1,
      scaleOptions: SCALE_OPTIONS,
      userDeptInfo:{},
      editableTabsValue: 'Todolist',
      editableTabs: [],
      tabIndex: 1,
      refreshId:0,
      defaultTabs:[
        {
          title: '个人中心',
          name: 'My',
          content: My,
          refreshId:0,
          show:true,
          important:true,
          todoCount:true
        },
        {
          title: '业绩表现',
          name: 'Performance',
          content: Performance,
          show:false,
          important:true
        },
        {
          title: '待办提醒',
          name: 'TodoList',
          content: TodoList,
          refreshId:0,
          show:false,
          important:true
        },
        {
          title: '订单',
          name: 'ProjectList',
          content: ProjectList,
          refreshId:0,
          show:false,
          important:true
        },
        {
          title: '商机',
          name: 'Business',
          content: Business,
          refreshId:0,
          show:false,
          important:true
        },
        {
          title: '客户',
          name: 'Client',
          content: Client,
          refreshId:0,
          show:false,
          important:true
        },
        {
          title: '项目',
          name: 'Item',
          content: Item,
          refreshId:0,
          show:false,
          important:true
        },
        {
          title: '财务部',
          name: 'FinanceDept',
          content: FinanceDept,
          refreshId:0,
          show:false,
          important:true
        },
        {
          title: '采购',
          name: 'purchase',
          content: purchase,
          refreshId:0,
          show:false,
          important:true
        },
        {
          title: '绩效',
          name: 'achievements',
          content: achievements,
          show:false
        },
        {
          title: '预付款管理',
          name: 'PrePayManage',
          content: PrePayManage,
          refreshId:0,
          show:false
        },
        {
          title: '服务器管理',
          name: 'ServerManage',
          content: ServerManage,
          show:false
        },
        {
          title: '网站使用统计',
          name: 'DataStatistics',
          content: DataStatistics,
          refreshId:0,
          show:true
        },
        {
          title: '发奖账户管理',
          name: 'PrizeAccount',
          content: PrizeAccount,
          refreshId:0,
          show:false
        },
        {
          title: '流程发起',
          name: '',
          content: '',
          refreshId:0,
          show:false,
          link:"https://www.jiandaoyun.com/dashboard#/"

        },
        {
          title: '项目管理',
          name: '',
          content: '',
          refreshId:0,
          show:false,
          link:"http://project.szltech.com:81/zentao/my/"

        },
        {
          title: '技术管理',
          name: '',
          content: '',
          refreshId:0,
          show:false,
          link:"http://monitor.szltech.com/"
        },
        {
          title: '文档梳理',
          name: '',
          content: '',
          refreshId:0,
          show:false,
          link:"https://szltech.yuque.com/dashboard"

        },
        {
          title: '行业追踪',
          name: '',
          content: '',
          refreshId:0,
          show:false,
          link:"https://research.szltech.com"

        },
        {
          title: '乐搭平台',
          name: '',
          content: '',
          refreshId:0,
          show:false,
          link:"https://leda.szltech.com/d5/pc/index.html"

        },
        {
          title: '乐搭组件库',
          name: '',
          content: '',
          refreshId:0,
          show:false,
          link:"https://szltech.yuque.com/docs/share/02e772f4-f4a5-437d-a2c1-d5c1d5f5921e?#"
        }
      ]
    }
  },
  
  watch: {
    /**
     * 监听打开新tab
     */
    '$store.state.projectInfo': {
      handler(newVal, oldVal) {
        // console.log('$store.state.projectInfo/newVal', newVal)
        let exitIdx = -1
        this.editableTabs.forEach((item, idx) => {
          if (item.project_id == newVal.projectId) {
            exitIdx = idx
          }
        })

        if (exitIdx !== -1) {
          //跳转到已存在的tab中
          this.editableTabsValue = this.editableTabs[exitIdx].name
        } else {
          //打开新tab
          this.handleTabsEdit(newVal.projectName, 'add', newVal.projectId,newVal.accu)
        }

      },
      deep: true
    },


    '$store.state.clueInfo': {
      handler(newVal, oldVal) {
        this.tabChange("Business")
        console.log('$store.state.clueId/newVal', newVal)
      },
      deep: true

    },

    editableTabsValue(newVal) {
      // console.log('editableTabsValue', newVal)
        let currentSelectTab = this.editableTabs.find(tabs=>tabs.name==newVal)
        if(currentSelectTab && currentSelectTab.hasOwnProperty('refreshId')){
          // console.log('有刷新属性需要的页面',newVal)
          this.refreshId += 1
        }

      this.$cookies.set('actived_tab', newVal)
    }
  },

  created() {
    // 尽早套用基础缩放，避免首屏先按 100% 画一遍再跳一下
    this.currentZoom = applyZoom();
    this.displayScalePref = getScalePref();
  },

  async mounted() {
    // DOM 已经渲染出来，用真实内容宽度再实测一次（created 时量不到顶栏的自然宽度）
    this.currentZoom = applyZoom();
    // 窗口变窄时自动比例要跟着收，避免放大后出现横向滚动条
    window.addEventListener('resize', this.handleViewportResize);
    await this.getUserDept()
    let isDebugOpen = false
    let performancePermissionSign = 0

    if(performancePermissionSign){
      //权限1则读取接口
      let res = await performancePermission({})
      let performancePermissionUserames = res.data.res
      // console.log('performancePermissionUserames',performancePermissionUserames)
      isDebugOpen = performancePermissionUserames.indexOf(this.$cookies.get("username"))
    }else{
      //所有人可见
      // console.log('所有人可见')
      isDebugOpen = 1
    }

    let visableTabs = []//默认存在的tab，不可删除
    if(isDebugOpen!==-1){
      this.debug = true

      if(this.userDeptInfo?.p_dept_name=="财务部"||this.userDeptInfo?.p_dept_name=="项目管理委员会"||this.userDeptInfo?.p_dept_name=="管理团队" || this.userDeptInfo?.p_dept_name=="人力行政部"
        || salesManager.concat(projectManager, departmentManager, businessManager, performanceManager).includes(this.$cookies.get("username")) ){
        visableTabs.push("Performance")
        this.defaultTabs.find(defaultTab=>defaultTab.name=="Performance").show=true
        visableTabs.push('ProjectList')
        this.defaultTabs.find(defaultTab=>defaultTab.name=="ProjectList").show=true
        visableTabs.push('TodoList')
        this.defaultTabs.find(defaultTab=>defaultTab.name=="TodoList").show=true
      }

      visableTabs.push('My')
      // if(this.userDeptInfo?.p_dept_name=="财务部"||this.userDeptInfo?.p_dept_name=="项目管理委员会"||this.userDeptInfo?.p_dept_name=="管理团队"
      //   || salesManager.concat(departmentManager, businessManager, clueWhite).includes(this.$cookies.get("username")) ){
      //   visableTabs.push("Business")
      //   this.defaultTabs.find(defaultTab=>defaultTab.name=="Business").show=true
      // }

      // if(this.userDeptInfo?.p_dept_name=="财务部"||this.userDeptInfo?.p_dept_name=="项目管理委员会"||this.userDeptInfo?.p_dept_name=="管理团队"
      //   || salesManager.concat(departmentManager, businessManager).includes(this.$cookies.get("username")) ){
      //   visableTabs.push("Client")
      //   this.defaultTabs.find(defaultTab=>defaultTab.name=="Client").show=true
      // }

      if(this.userDeptInfo?.p_dept_name=="财务部"||this.userDeptInfo?.p_dept_name=="项目管理委员会"||this.userDeptInfo?.p_dept_name=="管理团队"
        || projectManager.concat(departmentManager, businessManager).includes(this.$cookies.get("username")) ){
        visableTabs.push("Item")
        this.defaultTabs.find(defaultTab=>defaultTab.name=="Item").show=true
      }

      // if(this.userDeptInfo?.p_dept_name=="财务部"||this.userDeptInfo?.p_dept_name=="项目管理委员会"||this.userDeptInfo?.p_dept_name=="管理团队"
      //   || projectManager.concat(departmentManager, businessManager).includes(this.$cookies.get("username")) ){
      //   visableTabs.push("purchase")
      //   this.defaultTabs.find(defaultTab=>defaultTab.name=="purchase").show=true
      // }
      
      // if(this.userDeptInfo?.p_dept_name=="财务部"||this.userDeptInfo?.p_dept_name=="项目管理委员会" || this.$cookies.get("username") === '陈文瀚'){
      //   visableTabs.push("FinanceDept")
      //   this.defaultTabs.find(defaultTab=>defaultTab.name=="FinanceDept").show=true
      // }

      if(this.userDeptInfo?.p_dept_name=="财务部"||this.userDeptInfo?.p_dept_name=="项目管理委员会"||this.userDeptInfo?.p_dept_name=="管理团队"||this.$cookies.get("username")=="钟英杰"){
        visableTabs.push("PrizeAccount")
        this.defaultTabs.find(defaultTab=>defaultTab.name=="PrizeAccount").show=true
      }

      if(DataStatisticsManager.indexOf(this.$cookies.get("username"))!==-1){
        visableTabs.push("DataStatistics")
        this.defaultTabs.find(defaultTab=>defaultTab.name=="DataStatistics").show=true
      }

      // if(this.userDeptInfo?.p_dept_name=="财务部"|| this.userDeptInfo?.p_dept_name=="项目管理委员会"||
      //   salesManager.concat(departmentManager, businessManager, DataStatisticsManager).includes(this.$cookies.get("username"))
      // ){
      //   visableTabs.push("PrePayManage")
      //   this.defaultTabs.find(defaultTab=>defaultTab.name=="PrePayManage").show=true
      // }


      if(this.userDeptInfo?.p_dept_name=="财务部"|| this.userDeptInfo?.p_dept_name=="项目管理委员会"||
        (opsManager).includes(this.$cookies.get("username"))
      ){
        this.defaultTabs.find(defaultTab=>defaultTab.name=="ServerManage").show=true
      }

    }else{
      this.debug = false
      visableTabs = ['My']
    }

    this.editableTabs = [this.defaultTabs.find(dufaultTab=>dufaultTab.name==visableTabs[0])]
    this.editableTabsValue = visableTabs[0]
    // console.log('editableTabsValue',this.editableTabsValue)

    // let tabs = this.$cookies.get('tabs')
    let tabs = localStorage.getItem('tabs')

    if (tabs) {
      tabs = JSON.parse(tabs)
      // console.log('tabs',tabs)
      // console.log('tabs.tabs',tabs.tabs)
      for(let i = 0 ; i < tabs.tabs.length;i++){
        let item = tabs.tabs[i]
        // console.log('当前tabs',item)
        let insertIndex = 1
        if(visableTabs[0]!==item.name){
          let defaultTabItem = this.defaultTabs.find(defaultTab=>defaultTab.name==item.name)
          if(defaultTabItem){
            // console.log('tabs遍历/默认页',item.name)
            this.addDefaultTab(defaultTabItem)
          }else{
            // console.log('tabs遍历/详情页')
            this.handleTabsEdit(item.project_name, 'add', item.project_id, item.accu)
          }
        }else{
          // console.log('tabs遍历/默认第一页不用再添加',item.name)
        }
      }


      let actived_tab = this.$cookies.get('actived_tab')
      // console.log('actived_tab', actived_tab)
      if (actived_tab) {
        // console.log('this.editableTabs',this.editableTabs)
        if(!this.editableTabs.find(tabItem=>tabItem.name==actived_tab)){
          // console.log('找不到actived_tab')
          if(isDebugOpen!==-1){
            actived_tab = 'My'
          }else{
            actived_tab = 'ProjectList'
          }
        }
        let that = this
        this.$nextTick(function () {
          that.editableTabsValue = actived_tab
        })

      }
    }else{
      // console.log('tabs找不到')
    }
    this.getMyTodoCount()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleViewportResize);
    clearTimeout(this._scaleResizeTimer);
  },

  methods: {
    async getMyTodoCount(){
      let postData = {
        user:this.username,
        status:"1"
      }
      let res = await getMessage(postData)
      let resData = res.respData
      this.$store.commit('setTodoCount',resData.totalnums)
    },
    async getUserDept(){
      let res = await userDept({})
      if(res.respCode=="000000"){
        this.userDeptInfo = res.respData
        this.$store.commit("setUserDept",this.userDeptInfo)
        // console.log('home/this.userDeptInfo',this.userDeptInfo)

      }else{
        this.$message.warning(res.respMsg)
      }
    },

    loginOut() {
      this.$cookies.remove("token")
      this.$router.push("login")
    },

    // 顶部用户下拉的指令入口，保持 loginOut 的既有行为不变
    handleUserCommand(command) {
      if (command === "logout") {
        this.loginOut()
      } else if (command === "scale") {
        this.scaleDialogVisible = true
      }
    },

    // 窗口尺寸变化会改变“自动比例”的上限，防抖后重算一次
    handleViewportResize() {
      clearTimeout(this._scaleResizeTimer)
      this._scaleResizeTimer = setTimeout(() => {
        this.currentZoom = applyZoom()
      }, 150)
    },

    // 用户在弹窗里手动选了比例
    handleScaleChange() {
      this.currentZoom = setScalePref(this.displayScalePref)
      this.displayScalePref = getScalePref()
    },

    // 供界面显示“当前 120%”
    zoomText() {
      return describeZoom(this.currentZoom)
    },

    // 手动选的比例放不进当前窗口时的提示（自动值会实测退让，不会溢出，不提示）
    scaleOverflowTip() {
      if (this.displayScalePref === 'auto') return ''
      // 读 scrollWidth 会强制同步布局，拿到的是当前真实结果
      if (!hasHorizontalOverflow()) return ''
      return '当前窗口较窄，' + describeZoom(this.currentZoom) + ' 会出现横向滚动条，可先切回「自动」。'
    },

    tabChange(name){
      // console.log('tabChange',name)
      //add or jump
      let findOrderList = this.editableTabs.find(tab=>tab.name==name)
      if(findOrderList){
        // console.log('已存在快捷的tab，则跳转')
      }else{
        // console.log('不存在快捷的tab，则新建并跳转')
        this.addDefaultTab(this.defaultTabs.find(tab=>tab.name==name))
      }

      this.$nextTick(()=>{
        this.editableTabsValue = name
        this.saveTabs()
      })
    },

    addTodoList(){
      let todoList = {
        title: '待办提醒',
        name: 'TodoList',
        content: TodoList,
        refreshId:this.refreshId++
      }
      this.editableTabs.splice(1,0,todoList)
      this.saveTabs()

    },

    addOrderList(){
      let orderList = {
        title: '订单列表',
        name: 'ProjectList',
        content: ProjectList,
        refreshId:this.refreshId++
      }
      this.editableTabs.splice(1,0,orderList)
      this.saveTabs()

    },

    addDefaultTab(defaultTab){
      this.editableTabs.push(defaultTab)
      // this.editableTabs.splice(1,0,defaultTab)
      this.saveTabs()
    },

    handleTabsEdit(targetName, action, project_id,accu=0) {
      // console.log('handleTabsEdit', targetName, action, project_id)
      if (action === 'add') {
        let newTabName = ++this.tabIndex + '';
        let proIds = project_id.split(',')
        if(accu){
          this.editableTabs.push({
            project_id: project_id,
            project_name: targetName,
            title: targetName + '-' + ('共' + proIds.length + '个订单') + '-汇总订单详情',
            name: newTabName,
            // 利用project_id初始化ProjectDetail
            content: ProjectDetail,
            accu:accu
          });
        }else{
          this.editableTabs.push({
            project_id: project_id,
            project_name: targetName,
            title: targetName + '-订单详情',
            name: newTabName,
            // 利用project_id初始化ProjectDetail
            content: ProjectDetail,
            accu:accu
          });
        }

        this.editableTabsValue = newTabName;
      }
      if (action === 'remove') {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (targetName=='My') {
        }
        else if(targetName=='ProjectList'&&this.debug==false){
        } 
        else {
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter(tab => tab.name !== targetName);
        }
      }
      // console.log(JSON.stringify({actived:this.editableTabsValue,tabs:this.editableTabs}))
      this.saveTabs()
    },

    saveTabs(){
      localStorage.setItem('tabs',JSON.stringify({tabs: this.editableTabs}))
      // this.$cookies.set('tabs', JSON.stringify({tabs: this.editableTabs}))
      // console.log('handleTabsEdit', this.editableTabsValue)
    }

  }
}
</script>

<style lang="scss">
// .el-tabs.el-tabs--top.el-tabs--border-card {
//     height: calc(100% - 3px);
//     background: red;
// }
.el-tabs.el-tabs--top.el-tabs--border-card {
  height: 100%;
  //background: blue;
  // overflow: hidden;
  border: none;
  box-shadow: none;
}

.el-tabs__content {
  height: calc(100% - 40px);
  overflow-y: auto;
  //background: red;
  padding: 0 !important;
}

.el-tabs__nav {
  text-align: center;
}

.el-tab-pane {
  height: 100%;
  //background: red;
  // overflow:hidden;
}

.tab2{
  .el-tabs__item.is-active .el-icon-close::before {
    content: "";
    line-height: 33px;
    color: #FFFFFF;
    // margin-left: 15px;
    position: absolute;
    top: 0px;
    right: 14px;
    //background-color: green;
  }
  .el-icon-close::before {
    content: "";
    line-height: 33px;
    color: #8E93A8;
    position: absolute;
    top: 0px;
    right: 14px;
  }
  .el-icon-close {
    display: inline-block;
    width: 15px;
    //background-color: #3C903F;
  }
  .el-tabs__item.is-top{
    height: 33px;
    line-height: 33px;
  }
  .el-tabs__nav-scroll{
    height: 33px;
  }
}

.el-tabs--border-card>.el-tabs__header{
  z-index: 999;
  border-bottom:none;
  box-shadow: 0px 1px 1px rgba(0,0,0,.04);
  background: white;
}
/* 页签选中态 = 次级蓝 #4E96F0
   原来直接用顶栏的主色 #2783EF，选中页签和上面的导航栏是同色实心块，
   在同一列上首尾相接、糊成一片（撞色）；这里退到主色浅一档的次级蓝，
   仍然保留「选中 = 实心蓝块」的观感，但能和顶栏拉开层次。
   蓝的层级：主色 #2783EF（顶部导航）> 次级 #4E96F0（页签）> 三级（左侧菜单，见 LeftBar） */
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #4E96F0;
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #FFFFFF;
  min-width: 170px;
}

/* 未选中页签的 hover 也拉回主题蓝（Element 默认是 #409EFF，又是一个近似但不相同的蓝） */
.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
  color: #2783EF;
}


.el-tabs__item {
  min-width: 170px
}


.main {
  width: 100%;
  height: 100%;
  //width: 1920px;
  min-width: 1200px;
  min-height: 450px;
  // overflow: hidden;
  // background: blue;
}

.header {
  width: 100%;
  height: 53px;
  background: #2783EF;
  // border-bottom: 1px solid #F0F0F5;
  display: flex;
  /* flex-direction: row; */
  align-items: center;
}

.header .settings {
  // padding-left: 20px;
  // padding-top: 10px;
  align-items: center;
  margin-right: 24px;
  //position: absolute;
  //right: 40px;
  //top: 30px;
  // background: red;
  display: flex;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;

  .doc {
    margin-right: 16px;
    white-space: nowrap;

    a {
      text-decoration: none;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }

    /* 新版入口 CTA：白底蓝字（与左侧 Logo 白底板同语言），只用导航主题色，避免撞色 */
    a.doc-new-version {
      display: inline-flex;
      align-items: center;
      height: 28px;
      padding: 0 12px;
      border-radius: 14px;
      background: #FFFFFF;
      color: #2783EF;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-size: 14px;
      font-weight: 600;
      line-height: 1;
      white-space: nowrap;
      transition: background .2s ease, box-shadow .2s ease;

      &:hover {
        color: #2783EF;
        background: #EAF3FF;
        box-shadow: 0 2px 8px rgba(11, 60, 122, .2);
      }

      .doc-new-version__badge {
        display: inline-flex;
        align-items: center;
        height: 16px;
        padding: 0 5px;
        margin-right: 6px;
        border-radius: 8px;
        background: #EAF3FF;
        color: #2783EF;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: .5px;
        line-height: 1;
      }

      .doc-new-version__arrow {
        margin-left: 4px;
        font-size: 12px;
        transition: transform .2s ease;
      }

      &:hover .doc-new-version__arrow {
        transform: translateX(2px);
      }
    }
  }

  /* 用户菜单：头像 + 用户名 + 箭头，点开后才是退出登录 */
  .user-menu {
    // element-ui 的 .el-dropdown 自带 color:#606266，会把用户名染成灰色，这里显式覆盖回白色
    color: #FFFFFF;

    .user-menu__trigger {
      display: inline-flex;
      align-items: center;
      height: 28px;
      padding: 0 10px 0 4px;
      border-radius: 14px;
      cursor: pointer;
      white-space: nowrap;
      transition: background .2s ease;

      &:hover {
        background: rgba(255, 255, 255, .18);
      }
    }

    .user-menu__avatar {
      width: 22px;
      height: 22px;
      margin-right: 6px;
      border-radius: 50%;
      background: rgba(255, 255, 255, .25);
      color: #FFFFFF;
      font-size: 13px;
      line-height: 22px;
      text-align: center;
    }

    .user-menu__name {
      font-size: 14px;
      line-height: 1;
    }

    .user-menu__caret {
      margin-left: 5px;
      font-size: 12px;
      transition: transform .2s ease;
    }

    &:hover .user-menu__caret {
      transform: rotate(180deg);
    }
  }
}

/* 下拉浮层挂在 body 上，规则需要是全局的 */
.user-menu__popover {
  .el-dropdown-menu__item {
    font-size: 13px;

    .user-menu__logout-icon,
    .user-menu__scale-icon {
      margin-right: 6px;
      font-size: 14px;
    }
  }

  /* 显示比例当前值，靠右做弱提示 */
  .user-menu__scale-current {
    float: right;
    margin-left: 12px;
    color: #C0C4CC;
    font-size: 12px;
  }
}

/* 显示比例弹窗：弹窗挂到 body 上，规则需要是全局的 */
.scale-group {
  display: block;
}

.scale-radio {
  display: block;
  margin: 0 0 10px 0;
  line-height: 22px;

  &:last-child {
    margin-bottom: 0;
  }
}

.scale-tip {
  margin-top: 4px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #F5F7FA;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.scale-warn {
  margin-top: 4px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #FDF6EC;
  color: #E6A23C;
  font-size: 12px;
  line-height: 18px;
}

.header .branding {
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  letter-spacing: 1px;
  color: #FFFFFF;
}

/* Logo 用白色圆角底板与蓝色导航栏拉开对比：紫蓝渐变本身与背景蓝接近，仅靠加色或装饰解决不了辨识度 */
.header .branding .logo {
  width: 34px;
  height: 34px;
  padding: 6px;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 9px;
}

/* 品牌文字与 Logo 成组，字号收小以贴近导航文字，让三者风格统一 */
.header .branding .brand-name {
  margin-left: 12px;
  line-height: 1;
}


.content {
  width: 100%;
  // min-height: 920px;
  // background: green;
  height: calc(100% - 54px);

  .tab {
    height: 100%;
  }
}

.footer {
  width: 100%;
  height: 100px;
  background-color: #333333;
}
</style>
